const json = `<p>Guangzhou Qianqi IoT Technology Co., Ltd. (以下、「 Qianqi 」といいます) は、ユーザーに対し、この「 ix Camクラウド ストレージ
	ユーザー契約」(以下、「本契約」といいます)をよく読み、完全に理解するよう注意を促します。
	ユーザーは、本契約の条項、特に会社の責任、紛争解決、および法的適用を免除または制限する条項を注意深く読み、完全に理解する必要があります。責任を除外または制限する条件は太字でマークされており、ユーザーは注意深く読む必要があります。ユーザーは、本規約をよくお読みになり、同意するか同意しないかを選択してください
	(未成年者は法定保護者の同伴でお読みください)。ユーザーによるクラウド ストレージ サービスの使用は、本契約に同意し、本契約の条件に拘束されることに同意したものとみなされます。ユーザーが本契約に同意しない場合は、 ix Camクラウド
	ストレージ サービスを使用しないでください。 Qianqi は本契約を修正する権利を有し、更新された契約条件はix Camクラウド ストレージ サービスの公式 Web サイトに公開され、修正された契約書の発効日から発効します。</p>
<p class="subTitle">1. 一般原則</p>
<p>1.1 ix Camクラウド ストレージ サービスは、 Qianfangが大多数のスマート カメラ ユーザーに提供する中立的な情報ストレージ スペースであり、クラウド ストレージ テクノロジーを通じてスマート カメラのデータ
	ストレージ、同期、管理などのオンライン サービスをユーザーに提供するものであることをユーザーは理解する必要があります。ストレージスペースサービスは中立的な技術サービスプロバイダーです。</p>
<p>1.2 ix Camクラウド ストレージ サービスの種類、サービス標準、および請求標準は、本契約または両当事者によって別段の合意がない限り、 ix Cam APP スマート カメラ クラウド ストレージ
	インターフェイスおよび特定のサービス購入時のページの説明に準拠します。</p>
<p>、ユーザーによるix Camクラウドストレージサービスの利用に関する、ユーザー（以下「ユーザー」といいます）とQianqiおよびその関連会社および運営パートナー（以下「パートナー」といいます）との間の契約です。</p>
<p class="subTitle">2.サービス料金</p>
<p>ix Camクラウド ストレージ サービスに加入して使用するユーザーは、 Qianfangに対応する料金を支払うものとします。ユーザーは、自分のニーズに応じて、対応するix Camクラウド ストレージ
	パッケージを選択できます。パッケージ価格は、 Qianxianが発表する正式な価格に従うものとします。</p>
<p>ix Cam APPを通じてオンラインで直接支払いを行ってサービスを購入できます。ユーザーは、クラウド ストレージ サービスが仮想製品であり、購入成功後の返金はサポートされていないことを理解する必要があります。</p>
<p>3.3 Qiancai は、 ix Camクラウド ストレージ ユーザーに対してのみ請求書を発行し、第三者に対しては請求書を発行しません。 請求書を発行する必要がある場合は、 Qianguiカスタマー サービス ホットライン:
	020-34974033に電話して申請してください。</p>
<p>ix Camクラウド ストレージ規則に従って、リチャージ記録、請求書のヘッダー名、請求書発行金額などのスクリーンショットを含むがこれらに限定されない、請求書発行申請書および対応する資料を提出する必要があります。 Qianqi
	は申請書を受け取ってから 30 日以内に対応する金額の VAT 請求書を発行し、ユーザーに送信します。当該請求書が利用者が記入した送付先住所に送付された時点で、銀行は請求書発行義務を完了したものとみなされます。</p>
<p>3.3.2 請求書を繰り返し発行することはできません。ユーザーが提出した資料の誤りに起因する請求書のタイトル、送付先住所、その他の情報の誤りについては、ユーザーが責任を負うものとします。</p>
<p>3.4 ix Camクラウド ストレージ パッケージの有効期限が切れると、サービスは自動的に終了し、ユーザーの使用に影響します。ユーザーが継続して使用することを選択した場合は、パッケージの更新を購入する必要があります。</p>
<p class="subTitle">4.サービス規定</p>
<p>ix Camカメラのライブ ブロードキャスト ページの下部にある [クラウド ストレージ]をクリックして、購入ページに直接入ることができます。クラウド ストレージ サービスの有効期限が切れた場合は、[My Cloud Storage]
	ページにアクセスして [今すぐ更新] をクリックして、クラウド ストレージ サービスを購入して更新できます。</p>
<p>4.2 ユーザーが支払いを完了し、正常に購入すると、サービスは直ちに有効になります。クラウド
	ストレージのサービス時間は、ユーザーがパッケージを購入して選択するときに、対応する開始時間と終了時間とともに表示されます。計算方法は、ユーザーが現在クラウド ストレージ
	サービスを使用していない場合、またはサービスの有効期限が切れている場合のサービス時間です。購入の成功から計算されます。例: ユーザーが 2018 年 6 月 5 日の 11:30 に 7 日間のクラウド
	ストレージ年間サービスを正常に購入した場合、開始時刻は 2018 年 6 月 5 日の 11:30 となり、サービス終了日は 6 月 5 日となります。 , 2019年11時30分。ユーザーが現在クラウド ストレージ
	パッケージを使用している場合、更新サービス時間はクラウド ストレージ サービスの有効期限から計算されます。クラウド サービスの有効期限が 2019 年 6 月 5 日 11:30 の場合、更新購入したサービスの開始時刻は 2019
	年 6 月 5 日 11:30 となります。</p>
<p>4.3 サービスの発効後、カメラが物体の動きを検出すると、すぐにビデオをクラウドにアップロードして保存します。ユーザーは、カメラがスリープ状態になると、クラウド
	ストレージがビデオのアップロードを停止することに注意してください。サービスの有効期限が切れると、新しく生成されたモーション検出はクラウドにアップロードされなくなります。クラウドに保存されたビデオは毎日ローリングベースで削除されます。ユーザーが
	7 日間のローリング ループ録画を購入した場合、クラウド サービスは有効期限が切れた 2 日目に 1 日目のビデオを削除し、すべてのクラウド ビデオは有効期限の 7 日後に削除されます。</p>
<p>4.4 使用中、ユーザーはクラウド ストレージ表示ページの [メンバー管理] をクリックして、[ビデオ アップロード]
	スイッチを見つけることができます。スイッチをオフにすると、ビデオはクラウドへのアップロードを停止します。ユーザーは、クラウドストレージの閲覧ページで「削除」「ダウンロード」をクリックして、削除またはダウンロードが必要な動画を操作することもできます。
</p>
<p>4.5 ユーザーは、購入したパッケージが変更をサポートしていないことに同意します。パッケージを変更する必要がある場合は、現在購入したパッケージを使い切った後、再度購入することを選択する必要があります。</p>
<p>4.6 クラウド ストレージ サービスによるデバイスとアカウントのバインド クラウド ストレージ サービスを備えたデバイスが新しいアカウントにバインドされると、そのサービスを利用できなくなります。ユーザー A がクラウド ストレージ
	サービスを購入した後にマシンのバインドを解除し、ユーザー B がデバイスを再度バインドした場合、ユーザー B はクラウド内のユーザー A のビデオを視聴できなくなります。ユーザー B
	が使用する必要がある場合は、再度購入する必要があります。</p>
<p>4.7
	ビデオをクラウドにアップロードするプロセスは、ユーザーのネットワーク状態に影響されます。ネットワーク状態が良好な場合、カメラはデバイスのデフォルトの最高解像度のビデオをクラウドにアップロードします。ネットワークの状態が悪い場合は、ネットワークの状態に応じて一時的に解像度を下げる措置を講じ、アップロードされたビデオの完全性を確保するよう努めます。解像度を下げても正常にアップロードできない場合は、ビデオが失われている可能性があります。したがって、ユーザーは、帯域幅を占有するデバイスが多すぎることを避けることをお勧めします。
</p>
<p class="subTitle">5. 使用上の仕様</p>
<p>、法令を遵守することを前提として本契約に従ってix Camクラウドストレージサービスを利用することができ、本契約は以下の行為を行ってはなりません。</p>
<p>5.1.1 サービス上のすべての著作権情報を削除し、知的財産権を保護するためにix Camクラウド ストレージ サービスによって設定された技術的措置を変更、削除、または回避します。</p>
<p>5.1.2 ix Camクラウド ストレージ サービスのリバース エンジニアリング (逆アセンブリ、逆コンパイル、またはix Camクラウド ストレージ サービスのソース コードを取得するその他の試みなど)を実行する。</p>
<p>ix Camクラウド ストレージ サービスの運用における指示およびデータの改変または偽造、 ix Camクラウド ストレージ
	サービスの機能または運用効果の追加、削除または変更、または使用されるソフトウェアおよび方法の運用または公開これらの行為が商業目的であるかどうかに関係なく、上記の目的のため。</p>
<p>5.1.4 ix Camクラウド ストレージ サービスを使用して、ネットワーク セキュリティを危険にさらす行為を行うこと。これには、許可されていないデータを使用したり、許可されていないサーバー/アカウントに侵入したり、許可なくパブリック
	ネットワークや他人のオペレーティング システムに侵入したり、削除したり、変更したりする行為が含まれますが、これらに限定されません。保存された情報を許可なく追加して調査、スキャン、またはテストを試みる。 ix Camクラウド ストレージ
	サービスのシステムまたはネットワークの脆弱性、またはネットワーク セキュリティを損なうその他の行為、 ix Camクラウド ストレージ サービスまたは Web
	サイトの通常の動作を妨害または破壊しようとする試み、悪意のあるプログラムまたはウイルスを意図的に拡散するその他の行為。通常のネットワーク情報サービスを妨害し、TCP/IP パケット名または名前の一部を偽造します。</p>
<p>non-Qianda.comによって開発、認可、または認められたサードパーティ互換ソフトウェアおよびシステムを通じてix Camクラウド ストレージ サービスにログインまたは使用するか、または上記のツールを作成、公開、配布します。</p>
<p>5.1.6 Qianbaoの書面による同意がない限り、 ix Camクラウド ストレージ サービスおよびその情報に対するユーザーの不正な行為には、次の行為が含まれますが、これらに限定されません:
	使用、レンタル、貸与、コピー、変更、リンク、再印刷、コンパイル、関連する派生製品、作品、サービス、プラグイン、プラグイン、互換性、相互接続などを開発するために、ミラー サイトを公開、公開、確立し、許可なくix Camクラウド ストレージ
	サービスを使用すること。</p>
<p>5.1.7 ix Camクラウド ストレージ サービスを使用して、ユーザーの現地法に違反するコンテンツを公開、送信、配布、および保存する。ユーザーが中華人民共和国本土のユーザーである場合、 ix Camクラウド ストレージ
	サービスを使用して公開する。
	、国内法に違反し、危害を及ぼすコンテンツ、国家安全保障、祖国の統一、社会の安定、公序良俗に関連するコンテンツ、または不適切、侮辱的、中傷的、わいせつ、暴力的なコンテンツを送信、配布、保存すること。国内の法律、規制、政策に違反するもの。
</p>
<p>5.1.8 ix Camクラウド ストレージ サービスを使用して、他人の知的財産権、企業秘密、およびその他の法的権利を侵害するコンテンツを公開、送信、配布、および保存すること。</p>
<p>5.1.9 ix Camクラウド ストレージ サービスを使用して、広告情報やスパム情報を一括して公開、送信、配布する。</p>
<p>ix Camクラウド ストレージ サービスおよびix Camが提供するその他のサービスを、違法な方法、違法な目的、または本契約で許可されている使用と矛盾する方法で使用します。</p>
<p>5.2 情報公開仕様</p>
<p>ix Camクラウド ストレージ サービスを使用して公開できる情報コンテンツは、ユーザーがアップロードした情報コンテンツの知的財産権をユーザーが所有しているか、法的認可を得ていること、およびix Cam
	を使用するユーザーのあらゆる行為を保証する必要があります。クラウド ストレージ サービスは第三者の正当な権利と利益を侵害しません。</p>
<p>ix Camクラウド ストレージ
	サービスを使用する際、現地の法律と規制を遵守する必要があります。ユーザーが中華人民共和国のユーザーである場合、特に中国の法律と規制、社会主義制度、国家を遵守する必要があります。利益、国民の正当な権利と利益、社会および公の秩序、倫理や情報の信頼性などの「7
	つの重要事項」要件。</p>
<p>5.2.3 ユーザーは、 ix Camクラウド ストレージサービスを使用する際に、以下の行為を行ってはなりません。これには、以下の行為が含まれますが、これらに限定されません。</p>
<p>5.2.3.1 現地の法律や規制に違反するコンテンツを作成、コピー、公開、配布、保存すること。 ユーザーが中華人民共和国本土のユーザーである場合は、次の行為 (1) ～ (11) を行ってください。</p>
<p>(1) 憲法が定める基本原則に反対する。</p>
<p>(2) 国家安全保障を危険にさらし、国家機密を漏洩し、国家権力を転覆し、国家統一を損なう。</p>
<p>(3) 国家の名誉と利益を損なうこと。</p>
<p>(4) 民族憎悪、民族差別を煽り、民族の団結を損なうこと。</p>
<p>(5) 国の宗教政策を弱体化させ、カルトや封建的迷信を促進する。</p>
<p>(6) 風説を広め、社会秩序を乱し、社会の安定を損なう行為。</p>
<p>(7) わいせつ、ポルノ、ギャンブル、暴力、殺人、テロを広め、または犯罪を教唆する。</p>
<p>(8) 他人を侮辱し、又は名誉を毀損し、他人の正当な権利利益を侵害する行為。</p>
<p>(9) 社会秩序を破壊するために違法な集会、結社、行列、デモまたは人々の集まりを扇動すること。</p>
<p>(10) 違法な民間団体の名を借りた活動。</p>
<p>(11) その他、法律や行政法規で禁止されている内容が含まれます。</p>
<p>5.2.3.2 他人の評判権、肖像権、知的財産権、企業秘密およびその他の正当な権利を侵害するコンテンツを公開、送信、配布、および保存すること。</p>
<p>5.2.3.3 他者を誤解させたり欺いたりするために、事実を捏造し、真実を隠蔽する。</p>
<p>5.2.3.4 広告情報およびジャンク情報の発行、送信、および配布。</p>
<p>5.2.3.5 現地の法律や規制に違反するその他の活動に従事すること。</p>
<p>5.2.4ユーザーは、 Qianfangの許可なく、 ix Camクラウド ストレージ サービス内で広告の掲載や商品の販売などの商業活動を行うことはできません。</p>
<p>5.3 ユーザーは以下を理解し、同意します。</p>
<p>5.3.1 Qianfangは、ユーザーが上記の使用規定に違反している疑いがあるかどうかを判断し、その判断結果に基づいて、ユーザーの使用ライセンスの停止または終了、または本規約に従って講じることができるその他の制限措置を講じます。
</p>
<p>5.3.2 違法の疑いがある、または他人の法的権利を侵害している疑いがある、または本契約に違反している疑いのあるライセンス ソフトウェアの使用時にユーザーが公開した情報については、 Qianfangが直接削除します。</p>
<p>5.3.3 ユーザーによる上記の利用規定の違反により第三者に損害が生じた場合、ユーザーは自らの名において独立して法的責任を負う必要があり、銀行が損失や追加費用から保護されるようにする必要があります。</p>
<p>5.3.4
	ユーザーが関連法規定または契約に違反し、銀行に損失を与えた場合、または第三者からの請求の対象となった場合、または行政当局からの処罰を受けた場合、ユーザーは、結果として生じた損失および費用を銀行に補償するものとします。妥当な弁護士費用、調査費用、証拠収集費用。
</p>
<p class="subTitle">6. 契約違反に対する責任</p>
<p>6.1 Qianfang は、ユーザーの行動がix Camクラウド ストレージ サービス契約の条項に準拠しているかどうかを判断する権利を有し、ユーザーが関連する法律および規制、または本契約および関連規則の規定に違反していると思われる場合、
	Qianqi
	は以下の権利を有します。ユーザーの違反の程度に応じて予告なく決定し、違法情報の削除、ユーザーのix Camクラウドストレージサービスの利用制限、停止、終了、ユーザーの法的責任の調査、その他当社が適切と判断した措置を講じます。
	。キャッシュボックスが損失を被った場合（第三者からの請求や管理部門からの罰則を含みますがこれらに限定されません）、ユーザーは全責任を負うものとします。</p>
<p class="subTitle">7. サービスのリスクと免責事項</p>
<p>Qianfeng は、ユーザーが有効期限が切れる前にクラウド ストレージ パッケージをバックアップしなかったことに起因するデータの消失またはその他の損失について、一切の責任を負いません。</p>
<p>7.2 Qiangui は最新のテクノロジーを使用してサービス サポートを提供します。 Qianqi は、 ix Camクラウド ストレージ サービスが中断されない、またはエラーが発生しないことを保証しません。また、 ix Camクラウド
	ストレージ サービスのすべての欠陥が修正されることを保証しません。また、 ix Camクラウド ストレージ サービスがすべてのユーザーに対応できることを保証しません。要件。銀行は、それによって生じる結果については一切の責任を負いません。
</p>
<p>当行および提携先は、通信回線の故障、技術的問題、ネットワーク、コンピュータ端末機器の故障、システムの不安定、その他の不可抗力の事由など、第三者により利用者が被った損失については責任を負いません。</p>
<p>7.4 ix Camクラウド ストレージ サービスは、ほとんどのインターネット クラウド サービスと同様、ユーザーの理由、ネットワーク
	サービスの品質、社会環境などを含むがこれらに限定されない要因の違いによって影響を受け、また、他のユーザーが使用しているものなど、さまざまなセキュリティ問題によって影響を受ける可能性があります。ユーザーの情報が現実生活における嫌がらせにつながる、ユーザーがダウンロードおよびインストールした他のソフトウェア、またはアクセスした他の
	Web サイトに、ユーザーの端末情報やデータのセキュリティを脅かす「トロイの木馬」などのウイルスが含まれており、通常の使用に影響を及ぼします。
	ix Camクラウドストレージサービスなどユーザーは情報セキュリティとユーザーデータ保護に対する意識を強化し、損失や嫌がらせを避けるためにパスワード保護の強化に注意する必要があります。</p>
<p>7.5 Qianfeng は、事業開発および調整における会社の自主性を保護するために、
	Qianfangがユーザーに通知することなく、いつでもサービスを変更または中断する権利を有することをユーザーに特に通知します。ユーザーまたは第三者の権利を侵害した場合、その責任は第三者にあります。</p>
<p>7.6 法律や規制で別段の定めがない限り、 Qianfang は、 ix Camクラウド ストレージ
	サービスとそれに関連する技術および情報が安全、効果的、正確かつ信頼できるものであることを保証するために最善を尽くしますが、既存の技術には限界があるため、ユーザーは次のことを理解しています。 Qianfang
	ではこれを保証できません。</p>
<p>7.7 利益の損失、データの損失、事業中断による損害、その他の商業上の損害や損失を含むがこれらに限定されない、以下の状況に起因または関連して発生した人身傷害、または付随的または間接的な経済的損害は、ユーザーが負担する必要があります。
</p>
<p>ix Camクラウドストレージサービスの利用または不利用。</p>
<p>ix Camクラウド ストレージ サービスを使用したり、ユーザーのデータを許可なく変更したりする場合。</p>
<p>ix Camクラウドストレージサービスを利用するユーザーに発生した費用および損失。</p>
<p>ix Camクラウド ストレージ サービスに対するユーザーの誤解。</p>
<p>(5)その他、 ix Camクラウドストレージサービスに関連して当社の責によらない損失。</p>
<p>7.8 ユーザーは、 Qianqiが司法、規制当局、監督機関の要件または独自のビジネス上の理由に基づいて、ユーザーに提供されるix Camクラウド ストレージ
	サービスの全部または一部を一時停止、中断、または終了する権利を有することに同意します。銀行はこれについて一切の責任を負いません。</p>
<p>7.9 ユーザーは、 Qianfang がix Camクラウド ストレージ サービスにおけるユーザーのデータ ストレージのセキュリティを確保するために商業的に合理的な努力をすることを理解し、これに同意するものとしますが、
	Qianfangがデータを削除したり保存したりしないことをユーザーは理解する必要があります。または、バックアップの失敗の原因となる。</p>
<p class="subTitle">8. 知的財産に関する声明</p>
<p>8.1 Qiancaiは、 ix Camクラウド ストレージ サービスの知的財産権の所有者です。 ix Camクラウド ストレージ サービスのすべての著作権、商標、特許、企業秘密およびその他の知的財産権、ならびにix Camクラウド ストレージ
	サービスに関連するすべての情報コンテンツ
	(テキスト、画像、オーディオ、ビデオ、グラフ、インターフェースデザイン、レイアウトフレームワーク、関連データまたは電子文書など）は、現地の法律および規制および対応する国際条約によって保護されており、当社は上記の知的財産権を享受しています。
</p>
<p>8.2 Qianfangの書面による同意がない限り、ユーザーは上記の知的財産権を自ら実施、利用、譲渡することはできません。また、 Qianfang が上記の行為に対して法的責任を追及する権利を留保します。</p>
<p class="subTitle">9. 未成年者向けの利用規約</p>
<p>保護者の監督、指導、同意の下でix Camクラウド ストレージ サービスを使用する必要があります。</p>
<p>9.2 未成年ユーザーに対する特別な注意事項:</p>
<p>9.2.1 ix Camクラウド ストレージ
	サービスを使用する青少年は、保護者の監督と指導の下、合理的な範囲内でインターネットを正しく使用することを学び、仮想サイバースペースへの依存を避け、インターネットの良好な習慣を身に付ける必要があります。</p>
<p>9.2.2 10 代のユーザーは、「全国青少年インターネット文明条約」に従わなければなりません。</p>
<p>(1) オンライン学習を得意とし、悪い情報の閲覧を避けてください。</p>
<p>(2) 正直かつ友好的にコミュニケーションを図り、他人を侮辱したり欺いたりしないでください。</p>
<p>(3) 自己防衛の意識を高め、ネチズンとの安易なデートを避ける。</p>
<p>(4) ネットワークのセキュリティを維持し、ネットワークの秩序を乱さないこと。</p>
<p>(5) 身体的および精神的健康に有益である必要があり、仮想の時間と空間に耽溺するものではありません。</p>
<p class="subTitle">10. 契約の変更</p>
<p>10.1 Qiangui Company
	は、必要に応じて本契約の条件を変更する権利を有し、契約の条件が変更されると、修正された契約の条件は関連するページで発表されます。変更内容に同意できない場合は、ユーザー自らが本サービスを解約するものとします。ユーザーがサービスの利用を継続した場合、規約の変更に同意したものとみなされます。
</p>
<p>10.2レジ会社および協力会社は、必要に応じて提供する課金サービス、課金基準、課金方法、サービス料金およびサービス条件を修正または変更する権利を有します。ウェブサイトおよびそのパートナー企業は、関連する変更または変更を電子メールまたはその他の手段でユーザーに通知するために最善を尽くします。
</p>
<p class="subTitle">11. 準拠法と紛争解決</p>
<p>11.1 本契約の条件の有効性および解釈は、中華人民共和国本土の法律に準拠するものとします。関連する法規定がない場合は、国際的な商慣習が適用されます。</p>
<p>11.2 この協定の署名場所は広州市南沙区です。</p>
<p>11.3 ユーザーと当社は、 ix Camクラウド ストレージ
	サービスに起因するすべての紛争は交渉によって解決されるべきであることに同意します。交渉が不成立の場合、いずれの当事者も本契約が締結された場所を管轄する裁判所に訴訟を起こすことができます。</p>
<p class="subTitle">12. その他</p>
<p>12.1 Qianfang は、利用規約の変更、サービスの変更、および/またはその他の重要事項を、電子メールまたはテキスト メッセージ、Web
	アナウンス、またはQianfangが適切と判断するその他の手段を通じてユーザーに通知します。
	Qianqiが上記のいずれかの方法でユーザーにメッセージを送信した後、ユーザーが3日以内に書面による異議を提出しない場合、新しいメッセージの内容を受け入れたものとみなされます。</p>
<p>12.2
	ユーザーがix Camクラウドストレージサービスの特定のサービスを利用する場合、当該サービスには別途規約、関連業務規定等（以下総称して「個別規約」といいます。）が定められている場合があります。ユーザーは当該規約を読み、これに同意するものとします。サービスを利用する前に。
</p>
<p>12.3 本契約は 2025 年 8 月 2 日に発効し、2025 年 8 月 2 日に更新されます。</p>
<p>12.4 本契約のすべての条項のタイトルは、読みやすさを目的としたものであり、それ自体に実際の意味はなく、本契約の意味を解釈する根拠として使用することはできません。</p>
<p>12.5 本契約の条項の一部が何らかの理由で無効または強制不能であるかどうかに関係なく、残りの条項は引き続き有効であり、両当事者を拘束します。</p>
`

export default json
